import { CSSProperties } from "react";

/** 4px 栅格节奏 */
export const sp = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
} as const;

export const radius = {
  sm: 4,
  md: 6,
  lg: 8,
} as const;

export const CARD_GAP = sp.md;
export const SECTION_GAP = sp.lg;

export const pageWrap: CSSProperties = {
  padding: sp.lg,
};

export const sectionCard: CSSProperties = {
  marginBottom: SECTION_GAP,
  borderRadius: radius.md,
};

export const compactCard: CSSProperties = {
  marginBottom: CARD_GAP,
  borderRadius: radius.md,
};

/** 给数值上色：good/warn/bad 三档 */
export type Tone = "good" | "warn" | "bad" | "neutral";

export const toneColor: Record<Tone, string> = {
  good: "var(--semi-color-success)",
  warn: "var(--semi-color-warning)",
  bad: "var(--semi-color-danger)",
  neutral: "var(--semi-color-text-2)",
};

export const toneBg: Record<Tone, string> = {
  good: "var(--semi-color-success-light-default)",
  warn: "var(--semi-color-warning-light-default)",
  bad: "var(--semi-color-danger-light-default)",
  neutral: "var(--semi-color-fill-0)",
};
